import { Paper, Typography, Divider } from "@mui/material";
import { withStyles } from "@mui/styles";
import StatusLabel from "../StatusLabel/StatusLabel";
import {
	TimelineItem,
	TimelineDot,
	TimelineContent,
	TimelineSeparator,
	TimelineConnector,
	TimelineOppositeContent,
} from "@mui/lab";
import { getTimestampInLocalTime } from "../../util/dateUtil";
import { receiveStatus } from "../../util/receiveStatus";
import { useStyles } from "./History.styles";
import { StatusHistoryTimelineItemProps } from "./types";

const StyledTimelineContent = withStyles({
	root: {
		padding: "6px 0px",
	},
})(TimelineContent);

const ArrivalHeader = withStyles({
	root: {
		marginRight: "4px",
	},
})(Typography);
const StyledTimelineOppositeContent = withStyles({
	root: {
		flex: 0,
		padding: "0px 0px",
	},
})(TimelineOppositeContent);
export default function StatusHistoryTimelineItem({
	status,
	timestamp,
	userName,
	consignmentNumber,
	carrier,
	numberReceived,
	inFull,
}: StatusHistoryTimelineItemProps) {
	const classes = useStyles();
	const zonedDate = getTimestampInLocalTime(timestamp);

	const renderReceiveStatus = () => {
		return (
			<>
				<Typography variant="body2">{zonedDate}</Typography>
				<Typography variant="body2">{userName}</Typography>
			</>
		);
	};
	const renderArrivalStatus = () => {
		return (
			<>
				<div>
					<ArrivalHeader variant="body2" color="textSecondary">
						Received date:
					</ArrivalHeader>
					<Typography variant="body2" className={classes.arrivalDate}>
						{zonedDate}
					</Typography>
				</div>
				<div>
					<ArrivalHeader variant="body2" color="textSecondary">
						Con Note #:
					</ArrivalHeader>
					<Typography variant="body2">{consignmentNumber}</Typography>
				</div>
				<div>
					<ArrivalHeader variant="body2" color="textSecondary">
						Carrier:
					</ArrivalHeader>
					<Typography variant="body2">{carrier}</Typography>
				</div>
				<div>
					<ArrivalHeader variant="body2" color="textSecondary">
						Cartons:
					</ArrivalHeader>
					<Typography variant="body2">{numberReceived}</Typography>
				</div>
				<div>
					<ArrivalHeader variant="body2" color="textSecondary">
						Delivery status:
					</ArrivalHeader>
					<Typography variant="body2">{inFull}</Typography>
				</div>
				<div>
					<ArrivalHeader variant="body2" color="textSecondary">
						User:
					</ArrivalHeader>
					<Typography variant="body2">{userName}</Typography>
				</div>
			</>
		);
	};
	return (
		<TimelineItem className={classes.timelineItem}>
			<StyledTimelineOppositeContent />
			<TimelineSeparator>
				<TimelineDot />
				<TimelineConnector />
			</TimelineSeparator>
			<StyledTimelineContent>
				<Paper elevation={0} className={classes.timelineContent}>
					<StatusLabel status={status} size="small" />
					{status !== receiveStatus.arrived ? renderReceiveStatus() : renderArrivalStatus()}
				</Paper>
				<Divider />
			</StyledTimelineContent>
		</TimelineItem>
	);
}
